/***********************************************************
Royal Hawaiian Services
Alexander Self
2/6/18
Mech harvest create: Handles the creation of new records
***********************************************************/
import React, { Component } from 'react';
import MechHarvestTable from './mechHarvest_table';
class MechanicalHarvestDisplay extends Component {
  render() {
    if (!this.props.harvest) return <div></div>;
    const { 
      containerType, 
      employee, 
      equipmentNo, 
      estLbsPerContainer, 
      notes 
    } = this.props.harvest;
    //this.props.harvest.id = 0;
    return (
      <div className="card-body">
        <div className="row">
          <div className="col s6 m3 l3 xl3 b-r">
            <strong>Operator</strong>
            <p>{ employee }</p>
          </div>
          <div className="col s6 m3 l3 xl3 b-r">
            <strong>Equipment</strong>
            <p>{ equipmentNo }</p>
          </div>
          <div className="col s6 m3 l3 xl3 b-r">
            <strong>Container Type</strong>
            <p>{ containerType }</p>
          </div>
          <div className="col s6 m3 l3 xl3">
            <strong>Est Lbs/Container</strong>
            <p>{ estLbsPerContainer }</p>
          </div>
          <div className="p-b"></div>
          <hr />
          <p>
            <strong>{ notes }</strong>
          </p>
          <div>
            <MechHarvestTable 
              harvest={[this.props.harvest]} 
              field={{}} 
              totals={false} 
            />
          </div>
          <br />
        </div>
      </div>
    )
  }
}

export default MechanicalHarvestDisplay;




/* END */



// WEBPACK FOOTER //
// ./src/components/harvest/mechHarvest_display.jsx